
<span>
  <span class="popup-target" :data-position="position">
    <slot></slot>
  </span>
  <div class="ui popup">
    <p class="linebreak">{{ contents }}</p>
  </div>
</span>
